import { ValueOfKey } from '../../../utils-types';

export const CUSTOMER_COMMUNICATION_COLUMN = {
  NAME: 'NAME',
  LOCATION: 'LOCATION',
  GROUP: 'GROUP',
  COACH: 'COACH',
  START_DATE: 'START_DATE',
  STATUS: 'STATUS',
  CUSTOM_FILTER: 'CUSTOM_FILTER',
  ACTIONS: 'ACTIONS',
} as const;

export type CustomerCommunicationColumn = ValueOfKey<
  typeof CUSTOMER_COMMUNICATION_COLUMN
>;

export type ShowColumnsConfig = Record<CustomerCommunicationColumn, boolean>;

export const COLUMN_WIDTHS: Record<CustomerCommunicationColumn, string> = {
  NAME: '300px',
  LOCATION: '1fr',
  GROUP: '1fr',
  COACH: '1fr',
  START_DATE: '1fr',
  STATUS: '1fr',
  CUSTOM_FILTER: '1fr',
  ACTIONS: 'auto',
};
